import React, { Fragment } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { getCurrency } from "../../../../../../legacyComponents/util/formating";
import { styles } from ".";

import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { AllowanceButtons } from ".";
import { Color } from "../../../../../../legacyComponents/config/config.styles";
import { MAX_BENEFIT_AGE_LIST } from "../../../../../../legacyComponents/util/api/apis/employer/PermissibleClass/constants";

export default function Component(props) {
  let v2 = false;
  const permissibleClasses = props?.plan?.permissibleClasses;
  if (permissibleClasses?.length > 0) {
    v2 = permissibleClasses[0]?.v2;
  } else {
    v2 = true;
  }
  const { formik } = props;
  const { values, errors } = formik;
  const columns = v2
    ? ["selfAmount", "spouseAmount", "childAmount"]
    : ["selfAmount", "spouseAmount", "childAmount", "allAmount"];
  return (
    <Fragment>
      <AllowanceButtons {...props} />
      <Typography sx={styles.error}>
        {errors?.uploadError || "\u00A0"}
      </Typography>

      {/*   @ts-ignore */}
      <ThemeProvider theme={createTheme({ components: styles.table })}>
        <Table>
          <TableBody sx={{ "& *": { textAlign: "center !important" } }}>
            {!v2 && (
              <TableRow>
                <TableCell sx={{ width: "10%" }}>Age</TableCell>
                <TableCell sx={{ width: "22.5%" }}>Self Amount</TableCell>
                <TableCell sx={{ width: "22.5%" }}>
                  Self and Spouse Amount
                </TableCell>
                <TableCell sx={{ width: "22.5%" }}>
                  Self and Children Amount
                </TableCell>
                <TableCell sx={{ width: "22.5%" }}>
                  Self, Spouse and Children Amount
                </TableCell>
              </TableRow>
            )}
            {v2 && (
              <TableRow>
                <TableCell sx={{ width: "10%" }}>Age</TableCell>
                <TableCell sx={{ width: "22.5%" }}>Self Amount</TableCell>
                <TableCell sx={{ width: "22.5%" }}>
                  First Dependent Amount
                </TableCell>
                <TableCell sx={{ width: "22.5%" }}>
                  Additional Dependent Amount
                </TableCell>
              </TableRow>
            )}

            {Array(
              MAX_BENEFIT_AGE_LIST.MAXIMUM_AGE -
                MAX_BENEFIT_AGE_LIST.MINIMUM_AGE +
                1,
            )
              .fill(null)
              .map((_, index) => {
                const age = index + MAX_BENEFIT_AGE_LIST.MINIMUM_AGE;

                return (
                  <TableRow key={age}>
                    <TableCell>{age}</TableCell>

                    {columns.map((key) => {
                      let error =
                        values?.columnErrors?.[
                          key +
                            "_row" +
                            (index + MAX_BENEFIT_AGE_LIST.MINIMUM_AGE)
                        ] || false;
                      let fieldKey = `${key}${age}`;
                      // Annual cents -> monthly dollars.
                      let amount = getCurrency({
                        amount: values?.[fieldKey] / 12,
                        actions: ["divide"],
                        defaultReturn: "$0.00",
                      });
                      if (age === 21 && key === "selfAmount")
                        console.log(
                          "[MONEY]",
                          values?.[fieldKey],
                          "->",
                          amount,
                        );
                      return (
                        <TableCell
                          key={fieldKey}
                          style={{ color: error ? Color.danger : "#465578" }}
                        >
                          {amount}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </ThemeProvider>
    </Fragment>
  );
}
